// pages/Profile.jsx
import React from "react";
import { FaLocationArrow } from "react-icons/fa";
import { FiEdit2, FiPhone, FiBriefcase } from "react-icons/fi";
import { HiOutlineEye } from "react-icons/hi";
import { HiDocumentText } from "react-icons/hi2";
import { CiLocationOn } from "react-icons/ci";
import { FaPhoneAlt } from "react-icons/fa";
import { CiMail } from "react-icons/ci";

const Profile = () => {
  return (
    <div className="w-full max-w-5xl mx-auto px-6 py-10">
      {/* Header */}
      <div className="flex items-start sm:items-center gap-6 mb-6 flex-col sm:flex-row">
        <div className="h-16 w-16 sm:h-20 sm:w-20 rounded-full bg-[#002d2d] text-white flex items-center justify-center text-lg font-bold uppercase">
          KM
        </div>
        <div className="flex-1">
          <h2 className="text-2xl font-bold mb-1">kelly muller</h2>
          <div className="flex flex-wrap items-center text-sm text-gray-700 gap-3">
            <div className="flex  gap-2 items-center">
              <CiLocationOn /> <span>Toronto, ON Canada</span>
            </div>
            <div className="flex  gap-2 items-center"><CiMail /><span>kmuller1690@gmail.com</span></div>
            <div className="flex  gap-2 items-center">
              <FaPhoneAlt /> <span>Add Phone Number</span>
            </div>
          </div>
        </div>
        <button className="border px-4 py-2 rounded font-medium text-sm flex items-center gap-1">
          <FiEdit2 size={14} /> Edit
        </button>
      </div>

      {/* Visibility */}
      <div className="flex items-center gap-4 mb-8 flex-wrap">
        <div className="flex items-center gap-2 bg-green-50 text-green-800 text-sm font-medium px-3 py-1.5 rounded">
          <HiOutlineEye size={16} /> Your profile is public
        </div>
        <p className="text-sm text-gray-600">
          Employers can find your profile on ZipRecruiter and actively reach out
        </p>
        <button className="border px-4 py-1.5 rounded text-sm font-semibold">
          View as Employer
        </button>
        <button className=" text-sm font-semibold hover:underline">
          Set to Private
        </button>
      </div>

      {/* Progress Box */}
      <div className="border rounded-lg p-5 mb-8">
        <p className="text-sm font-bold mb-2 text-[#004349]">
          SUGGESTED FOR YOU
        </p>
        <h3 className="font-semibold text-sm mb-4">
          Complete your profile to stand out to employers!
        </h3>
        <div className="w-full h-1 bg-gray-200 rounded-full mb-2">
          <div className="h-full bg-[#004349] w-3/4 rounded-full"></div>
        </div>
        <p className="text-xs text-gray-500 mb-4">6/8 Complete</p>
        <div className="space-y-2">
          <div className="flex items-center gap-2 text-sm  font-medium cursor-pointer">
            <FiPhone size={16} /> Add phone number
          </div>
          <div className="flex items-center gap-2 text-sm  font-medium cursor-pointer">
            <FiBriefcase size={16} /> Add work experience
          </div>
        </div>
        <button className="text-sm text-black font-semibold mt-4 hover:underline">
          Show All
        </button>
      </div>

      {/* Resume Section */}
      <h3 className="text-lg font-bold mb-3">Resume</h3>
      <div className="border px-4 py-3 rounded mb-4 flex items-center justify-between">
        <div className="flex items-center gap-2 text-sm">
          <HiDocumentText className="text-gray-500" size={20} />
          <div>
            <p className="font-medium">Stephan Graham Resume.docx</p>
            <p className="text-xs text-gray-500">
              Added May 14, 2025 at 7:37 AM
            </p>
          </div>
        </div>
        <div className="flex items-center gap-4 text-sm font-medium">
          <button className="font-extrabold hover:underline">Replace</button>
          <button className="font-extrabold hover:underline">Delete</button>
        </div>
      </div>
    </div>
  );
};

export default Profile;
